
import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const reasons = [
  {
    title: 'Engineering-First Mindset',
    desc: 'We prioritize performance, security, and clean architecture over marketing fluff.'
  },
  {
    title: 'Clean Architecture',
    desc: 'Codebases that are modular, documented, and built for long-term survival.'
  },
  {
    title: 'Scalability as Standard',
    desc: 'Every system we build is designed to handle growth without structural fatigue.'
  },
  {
    title: 'Attention to Detail',
    desc: 'Precision at every level, from individual functions to system-wide workflows.'
  },
  {
    title: 'Direct Engineering Contact',
    desc: 'No middle managers. You work directly with the collective building your product.'
  }
];

const WhyBloomHive: React.FC = () => {
  return (
    <section id="why" className="py-32 bg-[#000000]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-20">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-zinc-600 text-[11px] uppercase tracking-[0.5em] font-bold mb-6">Philosophy</h2>
            <h3 className="text-4xl md:text-5xl font-bold tracking-tight mb-8">Why BloomHive?</h3>
            <p className="text-zinc-400 text-lg font-medium leading-relaxed max-w-md">
              We operate as a high-precision lab. Our goal is to build software that lasts, 
              infrastructure that remains invisible, and AI that actually integrates.
            </p>
          </motion.div>

          <div className="space-y-12">
            {reasons.map((reason, i) => (
              <motion.div
                key={reason.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex gap-6 group"
              >
                <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-violet-500 group-hover:border-violet-500/30 transition-colors">
                  <Check size={16} />
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2 tracking-tight group-hover:text-violet-400 transition-colors">{reason.title}</h4>
                  <p className="text-zinc-500 font-medium leading-relaxed">{reason.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyBloomHive;
